<template>
    <div class="ml-6 mr-6"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-breadcrumbs :items="page" class="pa-0 ma-0 my-6 mt-0 pt-0 "></v-breadcrumbs>
    <!--TOPIC DAN PEROIDE BERITA-->
             
    <!--TOPIC DAN PEROIDE BERITA-->
        <v-btn class="color-avatar3"
          v-scroll="onScroll"
          v-show="fab"
          fab
          dark
          fixed
          bottom
          right
          color="primary"
          @click="toBottom"
          >
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
            
        <v-layout row wrap class="my-4">
          <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
            <v-select class="elevation-0 shadow-0" dense
              :items="topicsentiment"
              outlined rounded
              label="Topic"
              >
            </v-select>
          </v-col>
          <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
            <v-select dark dense class="elevation-0" background-color="#0471A5"
              :items="periodeberita"
              solo rounded
              label="Periode Berita"
              >
              <template v-slot:append-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small width="120"
                          color="#0471A5"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          >
                          Custom
                        </v-btn>
                      </template>
                      <v-card>
                        <v-row justify="space-around" class="ma-4">
                          <v-date-picker dense
                            v-model="date1"
                            :show-current="false"
                            color="#0471A5">
                          </v-date-picker>
                          <v-date-picker class="ml-8"
                            v-model="date2"
                            show-current="2013-07-13"
                            color="#0471A5"
                            header-color="#0471A5">
                          </v-date-picker>
                        </v-row>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            @click="menu = false"
                            >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="primary"
                            text
                            @click="menu = false"
                            >
                            Set
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <!--calendar-->
          <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="4">
            <v-card height="37" outlined style="border-radius: 30px;"> 
              <v-card-text class="pa-2 px-4">
                <v-icon>mdi-calendar</v-icon> 
                16 January 2023 - 18 January 2023 
              </v-card-text> 
            </v-card>
          </v-col>
        </v-layout>
      <!--END TOPIC DAN PEROIDE BERITA-->
      
      <v-layout row wrap>
        <v-flex sm6 xs12 md6 lg8>
          <v-card height="auto" class="mr-6 mb-6 rounded-lg" flat>
            <v-row class="pa-0 ma-0">
              <v-flex lg9>
                <div class="example ml-4 mb-4"> 
                  <h4 class="mt-4 ml-4 font-weight-medium" style="color: #0471A5;">Sentiment Analysis</h4>
                  <apexcharts class="mr-3" width="100%" height="220px" type="" :options="sentimentanalysis" :series="seriessentiment"></apexcharts>
                </div>
              </v-flex>
              <v-flex lg3 xs12 sm12 md12>
                <v-flex xs12 sm12 md12 lg4>
                  <v-btn flat color="#fff" x-large width="180" height="80" class="elevation-0 mx-2 my-3" style="color: #0471A5;">
                    <v-card-text>
                      <h2 align="center" justify="center" class="text--teal darken-2">
                        <v-avatar class="color-avatar4" size="36">
                      <v-icon class="white--text">mdi-web</v-icon>
                    </v-avatar> 15,741</h2>
                      <h5 align="center" justify="center" class="text--teal darken-2 my-2">Total Berita Online</h5>
                    </v-card-text>
                  </v-btn>
                </v-flex>
  
                <v-flex xs12 sm12 md12 lg4>
                  <v-btn flat color="#fff" x-large width="180" height="80" class="elevation-0 mx-2 my-3" style="color: #0471A5;">
                    <v-card-text>
                      <h2 align="center" justify="center" class="text--teal darken-2">
                        <v-avatar class="color-avatar3" size="36">
                      <v-icon class="white--text">mdi-twitter</v-icon>
                    </v-avatar> 15,741</h2>
                      <h5 align="center" justify="center" class="text--teal darken-2 my-2">Total Tweet</h5>
                    </v-card-text>
                  </v-btn>
                </v-flex>
  
                <v-flex xs12 sm12 md12 lg4>
                  <v-btn flat color="#fff" x-large width="180" height="80" class="elevation-0 mx-2 my-3" style="color: #0471A5;">
                    <v-card-text>
                      <h2 align="center" justify="center" class="text--teal darken-2">
                        <v-avatar class="color-avatar2" size="36">
                      <v-icon class="white--text">mdi-youtube</v-icon>
                    </v-avatar> 15,741</h2>
                      <h5 align="center" justify="center" class="text--teal darken-2 my-2">Total Comment Youtube</h5>
                    </v-card-text>
                  </v-btn>
                </v-flex>
              </v-flex>
            </v-row>
          </v-card>
        </v-flex>
  
        <!---Dataset Category-->
        <v-flex sm12 xs12 md12 lg4>
          <v-card height="320px" width="100%" class="mr-4 mb-6 rounded-lg" flat>
            <div> 
              <v-card-text></v-card-text>
              <apexchart  height="220px"
              type="donut" 
              :options="chartPie" 
              :series="seriesdonut">
              </apexchart>
            </div>
          </v-card>
        </v-flex>
        <!---Dataset Category-->
  
        <v-flex sm12 xs12 md12 lg6>
          <v-card height="auto" class="mr-4 mb-6 rounded-lg" flat>
            <v-flex lg12>
              <div class="example"> 
                <h4 class="pt-4 ml-4 font-weight-medium" style="color: #0471A5;">Top Person</h4>
                <div>
                  <Toppersonbubble></Toppersonbubble>
                </div>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
  
        <v-flex sm12 xs12 md12 lg6>
          <v-card height="auto" class="mr-4 mb-6 rounded-lg" flat>
            <v-flex lg12>
              <div class="example"> 
                <h4 class="pt-4 ml-4 font-weight-medium" style="color: #0471A5;">Top Organisasi</h4>
                <div>
                  
                  <Toporgbubble></Toporgbubble>
                </div>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
  
        <v-flex sm6 xs12 md6 lg8>
          <v-card height="780px" class="mr-4 mb-6 rounded-lg" flat>
            <div class="example"> 
              <v-flex lg12>
                <v-row class="ma-0 pa-0">
                  <v-flex lg8 md8>
                    <h4 class="mt-4 ml-4 font-weight-medium" style="color: #0471A5;">Sentiment Analysis</h4>
                  </v-flex>
  
                  <v-flex lg4 md4>
                    <v-card-text class="d-flex align-end flex-column">
                      <div>
                        <v-btn small class="mr-4" outlined color="#0471A5">Capture</v-btn>
                      </div>
                    </v-card-text>
                  </v-flex>
                </v-row>
  
                <v-row class="ma-4">
                  <v-flex xs12 sm12 md12 lg12>
                    <v-tabs color="#0471A5" small>
                      <v-tab style="width: width 160px;">Netral 
                        <v-chip small class="ma-2" color="#0471A5" text-color="white">
                          45,95%
                        </v-chip>
                      </v-tab>
                        <v-tab-item>
                          <v-card width="100%" style="height: 600px;" flat class="overflow-card">
                          <v-row class="mb-4 mt-4">
                            <v-flex xs12 sm12 md12 lg12>
                              <v-list-item class="grow ml-4">
                                <v-list-item-content>
                                  <v-list-item-title>List-Based media object</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-btn class="ml-8" small
                                outlined
                                rounded
                                dark
                                color="#0471A5"
                                >
                                open
                              </v-btn>
                            </v-flex>
  
                            <v-flex xs12 sm12 md12 lg12>
                              <v-list-item class="grow ml-4">
                                <v-list-item-content>
                                  <v-list-item-title>List-Based media object</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-btn class="ml-8" small
                                outlined
                                rounded
                                dark
                                color="#0471A5"
                                >
                                open
                              </v-btn>
                            </v-flex>
  
                            <v-flex xs12 sm12 md12 lg12>
                              <v-list-item class="grow ml-4">
                                <v-list-item-content>
                                  <v-list-item-title>List-Based media object</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-btn class="ml-8" small
                                outlined
                                rounded
                                dark
                                color="#0471A5"
                                >
                                open
                              </v-btn>
                            </v-flex>
  
                            <v-flex xs12 sm12 md12 lg12>
                              <v-list-item class="grow ml-4">
                                <v-list-item-content>
                                  <v-list-item-title>List-Based media object</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-btn class="ml-8" small
                                outlined
                                rounded
                                dark
                                color="#0471A5"
                                >
                                open
                              </v-btn>
                            </v-flex>
  
                            <v-flex xs12 sm12 md12 lg12>
                              <v-list-item class="grow ml-4">
                                <v-list-item-content>
                                  <v-list-item-title>List-Based media object</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-btn class="ml-8" small
                                outlined
                                rounded
                                dark
                                color="#0471A5"
                                >
                                open
                              </v-btn>
                            </v-flex>
  
                            <v-flex xs12 sm12 md12 lg12>
                              <v-list-item class="grow ml-4">
                                <v-list-item-content>
                                  <v-list-item-title>List-Based media object</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-btn class="ml-8" small
                                outlined
                                rounded
                                dark
                                color="#0471A5"
                                >
                                open
                              </v-btn>
                            </v-flex>
  
                            <v-flex xs12 sm12 md12 lg12>
                              <v-list-item class="grow ml-4">
                                <v-list-item-content>
                                  <v-list-item-title>List-Based media object</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</v-list-item-title>
                                  <v-list-item-title class="body-2 grey--text">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-btn class="ml-8" small
                                outlined
                                rounded
                                dark
                                color="#0471A5"
                                >
                                open
                              </v-btn>
                            </v-flex>
                            </v-row>
                          </v-card>
                        </v-tab-item>
                        <v-tab>
                          Negatif <v-chip small class="ma-2" color="#0471A5" text-color="white">45,95%</v-chip>
                        </v-tab>
                        <v-tab-item>
                          <v-card width="100%" height="auto">
                            <v-card-text>
                              Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                              when an unknown printer took a galley of type and scrambled it to make a type 
                              specimen book. It has survived not only five centuries, but also the leap 
                              into electronic typesetting, remaining essentially unchanged. It was popularised 
                              in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
                              and more recently with desktop publishing software like Aldus PageMaker including 
                              versions of Lorem Ipsum.
                              Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                              when an unknown printer took a galley of type and scrambled it to make a type 
                              specimen book. It has survived not only five centuries, but also the leap 
                              into electronic typesetting, remaining essentially unchanged. It was popularised 
                              in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
                              and more recently with desktop publishing software like Aldus PageMaker including 
                              versions of Lorem Ipsum.
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
  
                        <v-tab>Positif 
                          <v-chip small class="ma-2" color="#1A8EC5" text-color="white">
                            45,95%
                          </v-chip>
                        </v-tab>
                        <v-tab-item>
                          <v-card width="100%" height="auto">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                            when an unknown printer took a galley of type and scrambled it to make a type 
                            specimen book. It has survived not only five centuries, but also the leap 
                            into electronic typesetting, remaining essentially unchanged. It was popularised 
                            in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
                            and more recently with desktop publishing software like Aldus PageMaker including 
                            versions of Lorem Ipsum.
                          </v-card>
                        </v-tab-item>
                      </v-tabs>
                    </v-flex>   
                    </v-row>
                  </v-flex>
                </div>
              </v-card>
            </v-flex>
  
        <v-flex sm6 xs12 md6 lg4>
          <v-card height="780px" class="mr-4 mb-6 rounded-lg" flat>
            <v-flex lg12>
              <div class="example"> 
                <v-row class="ma-0 pa-0"><v-flex>
                <h4 class="mt-4 ml-4 font-weight-medium" style="color: #0471A5;">Online News Share</h4></v-flex></v-row>
                <div align="center" justify="center">
                  <apexchart type="radialBar" width="100%" :options="onlinenew" :series="seriesonline"></apexchart>
                </div>
              </div>
            </v-flex>
            <v-flex lg12>
              <div class="example"> 
                <h4 class="mt-4 ml-4 font-weight-medium" style="color: #0471A5;">Online Media Share</h4>
                <div align="center" justify="center">
                  <apexchart type="radialBar" width="100%" :options="onlinemedia" :series="seriesmedia"></apexchart>
                </div>
              </div>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  
  <script>
  import VueApexCharts from 'vue-apexcharts';
  import HighCharts from 'highcharts';
  import highchartsMore from 'highcharts/highcharts-more';
  import Toppersonbubble from '@/components/Toppersonbubble'
  import Toporgbubble from '@/components/Toporgbubble'
  highchartsMore(HighCharts);
  
  export default {
    components: {
      apexcharts: VueApexCharts,
      Toppersonbubble,
      Toporgbubble
    },
    data() {
      return {
        fab: false,
        page: [
          {
            text: 'Home',
            disabled: false,
            href: 'breadcrumbs_dashboard',
          },
          {
            text: 'Dashboard',
            disabled: true,
            href: 'breadcrumbs_link_2',
          },
        ],
        /*Topic dan periode berita*/
        topicsentiment: ['Corona', 'Technology', 'Bisnis', 'Sains'],
        periodeberita: ['Today', 'Yesterday', 'Last 7 Days', 'Previous Week', 'Last 30 Days'],
        /*End Topic dan periode berita*/
  
  
        /*Bubblechart*/
         chart: [
          {
            name: 'Prabowo',
            amount: 40,
            color: '#C4C4C4'
          },
          {
            name: 'Jokowi',
            amount: 25,
            color: '#F88FB3',
          },
          {
            name: 'Anies',
            amount: 10,
            color: '#F1E987'
          },
          {
            name: 'SBY',
            amount: 15,
            color: '#B3B8F4'
          },
          {
            name: 'Ganjar',
            amount: 10,
            color: '#5EC3C2',
          },
          {
            name: 'Risma',
            amount: 5,
            color: '#AFDAF5'
          },
          {
            name: 'Sandiuno',
            amount: 6,
            color: '#C4C4C4'
          },
          
        ],
        /*end Bubblechart*/
  
        menuperiode: false,
        menu:false, 
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        date2: '2013-07-29',
        topic: [
          { title: 'Corona'},
          { title: 'Teknologi'},
          { title: 'Bisnis'},
          { title: 'Sains'},
        ],
  
        /*Chart sentiment analysis*/
        sentimentanalysis: {
          chart: { id: 'Memory Usage', type: 'line', },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          colors: ['#6F6F6F', '#FFB000', '#814AD6'], /*color line*/
          xaxis: {
            categories: ['Jan-21', 'Feb-21', 'Mar-21', 'Apr-21', 'Mei-21', 'Jun-21', 'Jul-21', 'Ags-21', 'Sep-21', 'Okt-21', 'Nov-21']
          }
        },
        seriessentiment: [
        {
          name: 'series-1',
          data: ['5', '10', '25', '130', '70', '20', '35', '66']
        },
        {
          name: 'series-2',
          data: ['120', '70', '50', '80', '60', '78', '70', '120']
        },
        {
          name: 'series-3',
          data: ['80', '55', '30', '10', '48', '5', '130', '90']
        },
      ],
      
      /*pie*/
      seriesdonut: [44, 55, 13],
      chartPie: {
        colors:['#FF4560', '#008FFB', '#00E396'],
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false
          },
          labels: ['Sentiment Negatif', 'Sentiment Positif', 'Sentiment Netral'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: 'bottom'
              }
            }
          }],
          plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
      },
      /*end pie*/
  
      /*radial*/
      seriesonline: [44, 55, 67, 83],
      onlinenew: {
        colors:['#38BABC', '#16A5A7', '#079092', '#057577', '#025354'],
        chart: {
          height: '50px',
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: '22px',
              },
              value: {
                fontSize: '16px',
              },
              total: {
                show: true,
                label: 'Total',
              }
            }
          }
        },
        labels: ['series-1', 'series-2', 'series-3', 'series-4'],
      },
  
      
          
      /*radial*/
      seriesmedia: [44, 55, 67, 83],
        onlinemedia: {
          colors:['#38BABC', '#16A5A7', '#079092', '#057577', '#025354'],
          chart: {
            height: '50px',
            width: '350px',
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: '22px',
                },
                value: {
                  fontSize: '16px',
                },
                total: {
                  show: true,
                  label: 'Total',
                }
              }
            }
          },
          labels: ['series-1', 'series-2', 'series-3', 'series-4'],
        },
      }
    },
  
   methods: {
      onScroll (e) {
        if (typeof window === 'undefined') return
        const bottom = window.pageYOffset ||   e.target.scrollBottom || 0
        this.fab = bottom > 50
      },
      toBottom(){
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })
      }
    }
  }
  </script>
  
  <style> 
  /*note css jangan diubah*/
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
  .apexcharts-toolbar {
    z-index: 0;
  }
  .row-pointer{
    cursor: grab;
  }
  svg {
    display: block;
    margin: 0 auto;
  }
  .chart {
    transition: transform 0.7s ease-in-out;
    text-anchor: middle;
    cursor: pointer;
  }
  .chart__circle {
    transition: r .3s ease-in-out;
  }
  .chart__label {
    fill: #fff;
    font-weight: bold;
    font-size: 12px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  .v-select.label{
    color: #fff;
  }
  .overflow-card{
      overflow-y: scroll;
      overflow-x: hidden;
  }
  .v-avatar.color-avatar
  {
    background-image: 
    linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
  }
  .v-avatar.color-avatar2
  {
    background-image: linear-gradient(to right top, #fd2f2c, #fe3b37, #fe4542, #fe4e4c, #fe5756, #fe6062, #fe696e, #fd7279, #fc7e88, #fa8a96, #f796a3, #f3a2af);
  }
  .v-avatar.color-avatar3
  {
    background-image: 
    linear-gradient(to right top, #5d8de3, #5c92e4, #5b96e5, #5c9be6, #5d9fe6, #5da3e7, #5ea6e7, #5faae8, #5faee9, #5fb2ea, #60b6eb, #61baec);
  }
  .v-avatar.color-avatar4
  {
    background-image: 
    linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
  }
  .v-avatar.color-avatar5
  {
    background-image: 
    linear-gradient(to right top, #fac070, #fcc46a, #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
  }
  .highcharts-figure, .highcharts-data-table table {
      min-width: 320px; 
      max-width: 800px;
      margin: 1em auto;
  }
  
  .highcharts-data-table table {
      font-family: Verdana, sans-serif;
      border-collapse: collapse;
      border: 1px solid #EBEBEB;
      margin: 10px auto;
      text-align: center;
      width: 100%;
      max-width: 500px;
  }
  .highcharts-data-table caption {
      padding: 1em 0;
      font-size: 1.2em;
      color: #555;
  }
  .highcharts-data-table th {
      font-weight: 600;
      padding: 0.5em;
  }
  .highcharts-data-table td, .highcharts-data-table th, .highcharts-data-table caption {
      padding: 0.5em;
  }
  .highcharts-data-table thead tr, .highcharts-data-table tr:nth-child(even) {
      background: #f8f8f8;
  }
  .highcharts-data-table tr:hover {
      background: #f1f7ff;
  }
  .rounded-lg{
    border-radius: 10px;
  }
  </style>